module.exports = __webpack_public_path__ + "static/media/trailofbits-light-mode.80074a1a.png";